/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Domain_Search_Modal_Buy_Addon_PriceInputs */

const en_domain_search_modal_buy_addon_price = /** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buy,  $${i?.price}/mo`)
};

const es_domain_search_modal_buy_addon_price = /** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comprar, $${i?.price}/mes`)
};

const fr_domain_search_modal_buy_addon_price = /** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Acheter, ${i?.price} $/mois`)
};

const de_domain_search_modal_buy_addon_price = /** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kaufen, ${i?.price} $/Monat`)
};

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const ja_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const zh_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const ar_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const id_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const it_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const ru_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const pt_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/** @type {(inputs: Domain_Search_Modal_Buy_Addon_PriceInputs) => LocalizedString} */
const ko_domain_search_modal_buy_addon_price = en_domain_search_modal_buy_addon_price;

/**
* | output |
* | --- |
* | "Buy, ${price}/mo" |
*
* @param {Domain_Search_Modal_Buy_Addon_PriceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_search_modal_buy_addon_price = /** @type {((inputs: Domain_Search_Modal_Buy_Addon_PriceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Search_Modal_Buy_Addon_PriceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_search_modal_buy_addon_price(inputs)
	if (locale === "es") return es_domain_search_modal_buy_addon_price(inputs)
	if (locale === "fr") return fr_domain_search_modal_buy_addon_price(inputs)
	if (locale === "de") return de_domain_search_modal_buy_addon_price(inputs)
	if (locale === "ja") return ja_domain_search_modal_buy_addon_price(inputs)
	if (locale === "zh") return zh_domain_search_modal_buy_addon_price(inputs)
	if (locale === "ar") return ar_domain_search_modal_buy_addon_price(inputs)
	if (locale === "id") return id_domain_search_modal_buy_addon_price(inputs)
	if (locale === "it") return it_domain_search_modal_buy_addon_price(inputs)
	if (locale === "ru") return ru_domain_search_modal_buy_addon_price(inputs)
	if (locale === "pt") return pt_domain_search_modal_buy_addon_price(inputs)
	return ko_domain_search_modal_buy_addon_price(inputs)
});